<template>
  <div class="video-container">
    <div id="placeholderVideoContainer">
      <div id="placeholderVideo">
        <iframe
          ref="placeholderVideo"
          src="https://player.vimeo.com/video/809930609?h=cb8256e06f&amp;title=0&amp;byline=0&amp;muted=1&amp;autoplay=1&amp;loop=1&amp;background=1&amp;app_id=58479"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen=""
          width="640"
          height="360"
          frameborder="0"
        ></iframe>
      </div>
      <div id="placeholderOverlay">
        <div class="video-overlay-content">
          play video
          <div class="video-overlay-content__play-line" />
          <span
            ref="playButton"
            class="video-overlay-content__play-button"
            @click="handlePlayButtonClick"
          >
            <FontAwesomeIcon icon="play" />
          </span>
        </div>
      </div>
    </div>
    <div
      id="mainVideoContainer"
      :class="{mainVideoFaded: !playing}"
    >
      <div id="mainVideo">
        <iframe
          ref="mainVideo"
          src="https://player.vimeo.com/video/807632986?h=ed195cc38c&amp;byline=0&amp;app_id=58479"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen=""
          width="640"
          height="360"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';
import scrollIntoView from 'scroll-into-view';

export default {
  name: 'HomeHeroVideo',
  components: { },
  data: function () {
    return {
      playing: false,
      placeholderPlayer: null,
      mainPlayer: null
    };
  },
  mounted () {
    this.placeholderPlayer = new Player(this.$refs.placeholderVideo);
    this.mainPlayer = new Player(this.$refs.mainVideo);
    this.mainPlayer.on('pause', () => {
      this.playing = false;
      this.placeholderPlayer.play();
    });
  },
  methods: {
    async handlePlayButtonClick (event) {
      event.preventDefault();
      if (!this.playing) {
        this.mainPlayer.play();
        this.placeholderPlayer.pause();
        const nav = document.getElementById('nav');
        nav.classList.add('stayDown');
        scrollIntoView(
          this.$refs.mainVideo,
          () => {
            nav.classList.remove('up');
            nav.classList.remove('stayDown');
          }
        );
      } else {
        this.mainPlayer.pause();
        this.placeholderPlayer.play();
      }
      this.playing = !this.playing;
    }
  }
};
</script>
